import { SelectFilterOption } from './types';

interface SelectFilterProps {
  name: string;
  options: SelectFilterOption[];
  onToggleOption: any;
}

export const SelectFilter = ({ name, options, onToggleOption }: SelectFilterProps) => {
  return (
    <div className="select-filter">
      {options.map((option: SelectFilterOption, i: number) => (
        <label className={option.selected ? 'checked' : ''} key={i}>
          {option.text}
          <input
            type="checkbox"
            name={name}
            checked={option.selected ?? false}
            onChange={(e: any) => onToggleOption(e, i)}
          />
        </label>
      ))}
    </div>
  );
};
